import {
    Container,
    Typography,
    Box,
    Button,
    Stack,
} from "@mui/material";
import React from 'react';
import { useTranslation, Translation } from "react-i18next";
import { toast } from "react-toastify";
import { getLang } from "../../helper/LangHelper";

export default function TestToast() {
    const { t } = useTranslation();

    let lang = getLang();

    const testToast = () => {
        toast.success("Success");
    };

    return (
        <Container maxWidth="lg">
            <Stack direction="column">
                <Typography variant="h3">Test Simple</Typography>


                <Box>
                    <p>Current Lang: {lang}</p>
                    <p>translateText: {t("testing.msg")}</p>
                </Box>
                <Button variant="contained" onClick={testToast}>Test Toast</Button>

            </Stack>
        </Container>
    )
}
